import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import './toBeAwareImage.scss';
import { getAssetUrl } from '@/utils/contentFullAsset';

const ToBeAwareImage = ({ image, title, content }: any) => {
  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node: any, children: any) => <p>{children}</p>,
      [BLOCKS.OL_LIST]: (_node: any, children: any) => <ol type="1">{children}</ol>,
      [INLINES.HYPERLINK]: (_node: any, children: any) => (
        <a
          href={_node?.data?.uri}
          rel="noopener noreferrer"
          target={
            _node?.data?.uri?.includes('www') || _node?.data?.uri?.includes('https')
              ? '_blank'
              : '_self'
          }
          title={children}
        >
          {children}
        </a>
      ),
    },
  };

  return (
    <div className="a-to-be-aware-image">
      <div className="a-to-be-aware-image__left">
        {image && image.gatsbyImage ? (
          <GatsbyImage
            className="a-to-be-aware-image__left__img"
            image={image.gatsbyImage}
            loading="eager"
            alt={
              image.description
                ? image.descripcion
                : image.title || 'Imagen ¡Estamos para ayudarte!'
            }
            title={
              image.description
                ? image.descripcion
                : image.title || 'Imagen ¡Estamos para ayudarte!'
            }
          />
        ) : (
          image?.file &&
          image?.file.url && (
            <img
              src={getAssetUrl(image)}
              alt={
                image.description
                  ? image.descripcion
                  : image.title || 'Imagen ¡Estamos para ayudarte!'
              }
              title={
                image.description
                  ? image.descripcion
                  : image.title || 'Imagen ¡Estamos para ayudarte!'
              }
              className="a-to-be-aware-image__left__img"
            />
          )
        )}
      </div>
      <div className="a-to-be-aware-image__right">
        {title && <h2>{title}</h2>}
        {content && content.raw && documentToReactComponents(JSON.parse(content?.raw), options)}
      </div>
    </div>
  );
};

export default ToBeAwareImage;
